import { GroupsSortBy, GroupsSortField } from "@custom-types/group-types";
import { SortItem, SortOption } from "@custom-types/sort-types";

/** All the possible headers for groups table. */
export enum GroupHeaders {
  /** Group thumbnail image */
  thumbnail = "Thumbnail",

  /** Group name */
  name = "Name",

  /** Number of group members */
  members = "Members",

  /** Number of active projects */
  projects = "Active projects",

  /** Group created date */
  createdDate = "Created Date",

  /** Any other possible options */
  options = "Options",
}

/** Default groups sort by option */
export const DEFAULT_GROUPS_SORT_BY = "name_ascending";

/** Available groups sort field options */
export const GROUPS_SORT_OPTIONS: Record<GroupsSortField, SortOption<GroupsSortField>> = {
  [GroupHeaders.name]: {
    field: GroupHeaders.name,
    label: "Name",
  },
  [GroupHeaders.members]: {
    field: GroupHeaders.members,
    label: "Members",
  },
  [GroupHeaders.projects]: {
    field: GroupHeaders.projects,
    label: "Projects",
  },
  [GroupHeaders.createdDate]: {
    field: GroupHeaders.createdDate,
    label: "Created Date",
  },
};

/** Map of the sort by options to the SortItem format */
export const GROUPS_SORT_BY_MAP: Record<GroupsSortBy, SortItem<GroupsSortField>> = {
  ["name_ascending"]: {
    field: GroupHeaders.name,
    sort: "asc",
  },
  ["name_descending"]: {
    field: GroupHeaders.name,
    sort: "desc",
  },
  ["members_ascending"]: {
    field: GroupHeaders.members,
    sort: "asc",
  },
  ["members_descending"]: {
    field: GroupHeaders.members,
    sort: "desc",
  },
  ["projects_ascending"]: {
    field: GroupHeaders.projects,
    sort: "asc",
  },
  ["projects_descending"]: {
    field: GroupHeaders.projects,
    sort: "desc",
  },
  ["created_date_ascending"]: {
    field: GroupHeaders.createdDate,
    sort: "asc",
  },
  ["created_date_descending"]: {
    field: GroupHeaders.createdDate,
    sort: "desc",
  },
};
